export enum PERMISSION_ACCESS_TYPES {
  INTRODUCER_PORTAL = "ACCESS_INTRODUCER_PORTAL",
  CREDIT_PLATFORM = "ACCESS_CREDIT_PLATFORM",
}
